import { render, staticRenderFns } from "./MagazzinoListiniListPage.vue?vue&type=template&id=15940bf0"
import script from "./MagazzinoListiniListPage.vue?vue&type=script&lang=js"
export * from "./MagazzinoListiniListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports